var _defs, _path, _b, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "157px",
    height: "152px",
    viewBox: "-0.5 -0.5 157 152",
    content: "<mxfile host=\"Electron\" modified=\"2020-04-28T10:37:06.397Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_3) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/12.1.0 Chrome/76.0.3809.139 Electron/6.0.7 Safari/537.36\" version=\"12.1.0\" etag=\"pqAXHO1km4jwjB2ZeF9Q\" type=\"device\" pages=\"3\"><diagram id=\"B71qBBbOGCBRxY7xdBQa\">rVXbjpswEP0apPYhFeBAyOOSbNt9qFQplfrsgAPWGps6TiH9+s5gm0uSlbZSiRSGMxfPzDkhAdk1/RdN2/qbKpkI4rDsA7IP4nhLYvhG4GqBNNtaoNK8tFA0AQf+hzkwdOiFl+y8CDRKCcPbJVgoKVlhFhjVWnXLsJMSy1NbWrE74FBQcY/+5KWpLZrFmwn/ynhV+5Oj1M3XUB/sJjnXtFTdDCLPAdlppYy1mn7HBO7O78XmfX7DOzammTTvSXBE/Kbi4mZzfZmrHxZabNGsWU8rJQOSt0zzhhmmJ/S7h2CCvKu5YYeWFpjWgQIAq00j4CkCUytDDcdK+1WUYMLZMhx+ikmabrIwI9GGJOk6RZ/R6nVcMyiA5CcuxE4JpYcGySnBzxg686TDhRlKmhluL8Dd9Ewb1r+5wWjkBfTMFIyprxDiE7Zrm+K0HK+Jfe4mZUReuPVMFdvMCdKJsRpLT3yB4Sh7TB95QF8qDO6ipXLBY/rrgqLKC7uGJ3Dq6vghgemgOTgpXJgf0cYFhbi71Yk2XFxtGtSiTTs4CVnD3QD1Z3BI1mFV1eDRNzHLcpZwLJaFbT/6gAWzooJX0joL4ABU5t2DrlZnKyz0S6UbKqbZwKrcfVjC0QMvLx6CjR5vwwCz6/LwzS8A27qRMIMJ6HEIwOZaxaUZeEzyINkDQi9GOVljghtqL9gJS6HiOLxPnhxsVGs5K7isfuDDfoVbE/TIRE6L10qriyy9hKWS7P+oN47SG/WGd+rNHojXh/2DeOFxeq8NvtmfA3n+Cw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 49.03 26 L 106.97 26 L 133 75 L 106.97 124 L 49.03 124 L 23 75 Z",
    fill: "#f5f5f5",
    stroke: "#666666",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    transform: "rotate(-152,78,75)",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.5,25.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "none",
    width: 62,
    height: 94,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "rgb(51 , 51 , 51)",
      fontFamily: "&quot",
      fontSize: 80,
      textAlign: "center",
      whiteSpace: "normal"
    }
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "II")))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 31,
    y: 53,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.78d1c60bb08c940c21d793b73c1636cc.svg";
export { ForwardRef as ReactComponent };